import { prefixWithSeparator as habitatPrefix } from './habitat';
import { prefix as schemePrefix } from './scheme';
const prefix = `votingPolicyGrants/`;
export const IDToName = ({ habitatID, schemeID, grantID }) => {
    return habitatPrefix + habitatID + '/' + schemePrefix + schemeID + '/' + prefix + grantID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 6) {
        throw new Error(`bad scheme voting policy grant name: ${name}`);
    }
    return {
        habitatID: parts[1],
        schemeID: parts[3],
        grantID: parts[5],
    };
};
